// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/** @ignore *//** */
const config = {
  version: '2.24.1',
  type: 'js'
};

export default config;
